
  <div class="col-sm-12 p-1 rounded border">
      <label class="d-block fw-normal text-start p-1">
        Campos marcados com <span class="asterisco fw-bold">*</span> são obrigatórios.
      </label>
      <form [formGroup]="fichaInscricaoForm"
            (ngSubmit)="onSubmitForm(fichaInscricaoForm.value)"
            novalidate role="form">

        <!-- INÍCIO DO TIPO COTISTA -->
      <div class="row mb-1" *ngIf="isExibeOpcaoCotista">
        <label for="tipoCotista" class="d-inline"><b>Tipo Cotista</b>
          <label class="asterisco">&nbsp;*</label>
        </label>
        <div class="col-sm-4 mb-1" *ngFor="let cotista of listaRadioCotista">
          <div class="form-group">
            <div class="input-group input-group-sm">
              <span class="input-group-text">
                <input type="radio"
                      formControlName="codTpCotista"
                      [value]="cotista.codigo"
                      [ngClass]="{'is-invalid': isCotista && hasRequired('codTpCotista') }"
                      (change)="cotistaObrigatorio()" [id]="cotista.codigo" />
              </span>
              <label [for]="cotista.codigo" class="form-control text-start p-1" disabled>{{ cotista.descricao }}</label>
            </div>
          </div>
        </div>
        <div *ngIf="isExibeOpcaoCotista && hasRequired('codTpCotista')" class="text-danger mensagemAlert">
          {{this.msgAlert}}
        </div>
      </div>
        <!-- FIM DO TIPO COTISTA -->

        <!-- <div class="mb-1"> -->

          <!-- INÍCIO DA IDENTIFICAÇÃO -->
          <div class="row mb-1">
            <!-- <label for="nomeIdentificacao" class="d-block"><b>Identificação</b></label> -->
            <div class="col-sm-3 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text p-1">CPF</span>
                  <span class="form-control text-center p-1" disabled>{{ this.dtoAcesso.cpf | cpf }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-9 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text p-0">Nome
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="text" class="form-control p-0" name="txtNome"
                        maxlength="60" placeholder="Digite o nome"
                    formControlName="nome" 
                    inputrestriction="somenteletras"
                    [ngClass]="{'is-invalid': hasRequired('nome') }" />
                </div>
              </div>
              <div *ngIf="hasRequired('nome')" class="text-danger mensagemAlert">
                {{ this.msgAlert }}
              </div>
            </div>
          </div>
          <!-- FIM DA IDENTIFICAÇÃO -->

          <!-- INÍCIO DA FILIAÇÃO -->
          <div class="row mb-1">
            <!-- <label class="d-block"><b>Filiação</b></label> -->
            <div class="col-sm-6 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Pai</span>
                  <input type="text"
                        class="form-control"
                        name="txtPai" maxlength="60"
                        placeholder="Digite o nome do pai"
                        formControlName="pai"
                        inputrestriction="somenteletras"
                        [ngClass]="{'is-invalid': hasRequired('pai') }" />
                </div>
              </div>
              <div *ngIf="hasRequired('pai')" class="text-danger mensagemAlert">
                {{ this.msgAlert }}
              </div>
            </div>
            <div class="col-sm-6 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Mãe
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="text"
                        class="form-control"
                        name="txtMae"
                        maxlength="60"
                        placeholder="Digite o nome da mãe"
                        formControlName="mae" 
                        inputrestriction="somenteletras"
                        [ngClass]="{'is-invalid': hasRequired('mae') }" />
                </div>
              </div>
              <div *ngIf="hasRequired('mae')" class="text-danger mensagemAlert">
                {{ this.msgAlert }}
              </div>
            </div>
          </div>
          <!-- FIM DA FILIAÇÃO -->

          <!-- INÍCIO DA IDENTIDADE -->
          <div class="row mb-1">
            <label class="d-block"><b>Identidade</b></label>
            <div class="col-sm-3 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Nº
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="text" class="form-control" 
                    name="txtIdentidade" 
                    maxlength='15'
                    placeholder="Digite o número da identidade" 
                    formControlName="rg" 
                    required
                    mask="000000000000000"                    
                    (keypress)="soNumeros($event)"
                    appOnlyNumbers                
                    [ngClass]="{'is-invalid': hasRequired('rg') }" />
                </div>
                <div *ngIf="hasRequired('rg')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>

            <div class="col-sm-3 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Órgão
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="text" class="form-control" name="txtIdOrgao" maxlength='10' placeholder="Digite o órgão"
                    formControlName="rgOrgao" [ngClass]="{'is-invalid': hasRequired('rgOrgao') }" 
                    inputrestriction="somenteletras" />
                </div>
                <div *ngIf="hasRequired('rgOrgao')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>

            <div class="col-sm-2 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">UF</span>
                  <select class="form-select" name="optufident" formControlName="rgUf"
                    [(ngModel)]="fichaInscricao.rgUf">
                    <option value="">Selecione</option>
                    <option *ngFor="let uf of listaComboFederacao" [value]="uf.codigo">
                      {{ uf.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Data de Expedição</span>
                  <input type="date" class="form-control" name="txtDtexp" min="1900-01-01" max="2100-12-31"
                    formControlName="rgDataExp" [ngModel]="fichaInscricao.rgDataExp | date: 'yyyy-MM-dd'"
                    inputrestriction="somentenumeros"
                    (keypress)="soNumeros($event)"
                    (blur)="validaDataExpedicao()"
                    [ngClass]="{'is-invalid': hasRequired('rgDataExp') }"/>
                </div>
                <div *ngIf="hasRequired('rgDataExp')" class="text-danger mensagemAlert">
                  {{ this.msgAlertDataExpedicaoInvalida }}
                </div>
              </div>
            </div>
          </div>
          <!-- FIM DA IDENTIDADE -->

          <!-- INÍCIO DA OAB / NACIONALIDADE / NATURALIDADE -->
          <div class="row mb-1">
            <div class="col-sm-3 mb-1">
              <label class="d-block"><b>OAB</b></label>
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Nº</span>
                  <input type="text" class="form-control" name="txtNumOab" maxlength="10"
                    placeholder="Digite o número da OAB" formControlName="numOAB" 
                    inputrestriction="somentenumeros"
                    (keypress)="soNumeros($event)" />
                </div>
              </div>
            </div>
            <div class="col-sm-3 mb-1">
              <label class="d-block">&nbsp;</label>
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Estado</span>
                  <select class="form-select" name="sltOabEstado" formControlName="orgaoExpOAB"
                    [(ngModel)]="fichaInscricao.orgaoExpOAB">
                    <option value="">Selecione</option>
                    <option *ngFor="let estado of listaComboFederacao" [value]="estado.codigo">
                      {{ estado.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <label for="nacionalidade" class="d-block"><b>Nacionalidade</b></label>
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">País</span>
                  <select class="form-select" name="sltNacionalidade" formControlName="nacionalidade"
                          (change)="habilitaCampoNaturalidade($any($event.target).value)">
                          <option value="">Selecione</option>
                          <option *ngFor="let pais of listaComboPais" [value]="pais.codigo">
                            {{ pais.descricao }}
                          </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <label for="naturalidade" class="d-block"><b>Naturalidade</b></label>
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Estado</span>
                  <select class="form-select" name="sltNaturalidade" formControlName="naturalidade">
                          <option value="">Selecione</option>
                          <option *ngFor="let federacao of listaComboFederacao" [value]="federacao.codigo">
                            {{ federacao.descricao }}
                          </option>
                  </select>
                </div>
              </div>
            </div>

          </div>
          <!-- FIM DA OAB / NACIONALIDADE / NATURALIDADE -->

          <!-- INÍCIO DO NASCIMENTO / ESCRITA -->
          <div class="row mb-1">
            <div class="col-sm-3 mb-1">
              <div class="form-group">
                <label class="d-block"><b>Nascimento</b></label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Data
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="date" class="form-control" name="txtDtNasc" min="1900-01-01" max="2100-12-31"
                    formControlName="dtNascimento" [ngModel]="fichaInscricao.dtNascimento | date: 'yyyy-MM-dd'"
                    inputrestriction="somentenumeros" 
                    (keypress)="soNumeros($event)"
                    [ngClass]="{'is-invalid': hasRequired('dtNascimento') }"
                    (change)="validaDataNascimento()" />
                </div>
                <div *ngIf="hasRequired('dtNascimento')" class="text-danger mensagemAlert">
                  {{ this.msgAlertDataNascimentoInvalida == '' ? this.msgAlert : this.msgAlertDataNascimentoInvalida }}
                </div>
              </div>
            </div>
            <div class="col-sm-3 mb-1">
              <div class="form-group">
                <label class="d-block">&nbsp;</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Sexo
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <select class="form-select" name="sltSexo" formControlName="sexo" required
                    [ngClass]="{ 'is-invalid': hasRequired('sexo') }" [(ngModel)]="fichaInscricao.sexo">
                    <option value="">Selecione</option>
                    <option *ngFor="let sexo of listaComboSexo;" [value]="sexo.codigo">
                      {{sexo.descricao}}
                    </option>
                  </select>
                </div>
                <div *ngIf="hasRequired('sexo')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="d-inline"><b>Escrita</b>
                  <label class="asterisco">&nbsp;*</label>
                </label>
                <div class="input-group input-group-sm">
                  <div class="form-check form-check-inline" *ngFor="let escrita of listaComboEscrita">
                    <input class="form-check-input" type="radio" name="escrita" formControlName="escrita"
                      [value]="escrita.codigo" [id]="escrita.codigo" />
                    <label [for]="escrita.codigo" class="form-check-label">{{ escrita.descricao }}</label>
                  </div>
                </div>
                <div *ngIf="hasRequired('escrita')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>
          </div>
          <!-- FIM DO NASCIMENTO / ESCRITA -->

          <!-- INÍCIO DO TURNO -->
          <div class="row mb-1">
            <label class="d-block"><b>Turno</b></label>
            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">1ª Opção
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <select class="form-select" name="sltTurno1" formControlName="codTurno"
                    [ngClass]="{ 'is-invalid': hasRequired('codTurno') }" (change)="validarTurno()"
                    [(ngModel)]="fichaInscricao.codTurno">
                    <option value="">Selecione</option>
                    <option *ngFor="let turno of listaComboTurno" [value]="turno.codigo">
                      {{ turno.descricao }}
                    </option>
                  </select>
                </div>
                <div *ngIf="hasRequired('codTurno')" class="text-danger mensagemAlert">
                  {{ (this.msgAlertTurno === '') ? this.msgAlert : this.msgAlertTurno }}
                </div>
              </div>
            </div>

            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">2ª Opção
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <select class="form-select" name="sltTurno2" formControlName="codTurnoFake"
                    [ngClass]="{ 'is-invalid': hasRequired('codTurnoFake') }" (change)="validarTurno()"
                    [(ngModel)]="fichaInscricao.codTurnoFake">
                    <option value="">Selecione</option>
                    <option *ngFor="let turno of listaComboTurno" [value]="turno.codigo">
                      {{ turno.descricao }}
                    </option>
                  </select>
                </div>
                <div *ngIf="hasRequired('codTurnoFake')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>

            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Ciência do Concurso
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <select class="form-select" name="rbCiencia" formControlName="cienciaConcurso"
                    [ngClass]="{ 'is-invalid': hasRequired('cienciaConcurso') }"
                    [(ngModel)]="fichaInscricao.cienciaConcurso">
                    <option value="">Selecione</option>
                    <option *ngFor="let concurso of listaComboCienciaConcurso" [value]="concurso.codigo">
                      {{ concurso.descricao }}
                    </option>
                  </select>
                </div>
                <div *ngIf="hasRequired('cienciaConcurso')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>
          </div>
          <!-- FIM DO TURNO -->

          <!-- INÍCIO DO FACULDADE -->
          <div class="row mb-1">
            <div class="col-sm-8">
              <div class="form-group">
                <label class="d-block"><b>Faculdade</b></label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Instituição
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <select class="form-select"
                          name="sltInstituicao"
                          formControlName="instituicao"
                          [ngClass]="{ 'is-invalid': hasRequired('instituicao') }">
                    <option value="">Selecione</option>
                    <option *ngFor="let instituicao of listaComboInstituicao" [value]="instituicao.codigo">
                      {{ instituicao.descricao }}
                    </option>
                  </select>
                </div>
                <div *ngIf="hasRequired('instituicao')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label class="d-block"><b>Conclusão do Curso</b></label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Mês</span>
                  <select class="form-select" formControlName="mesColacaoGrau">
                    <option value="">Selecione</option>
                    <option *ngFor="let mes of listaComboMes" [value]="mes.codigo">
                      {{ mes.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label class="d-block">&nbsp;</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Ano</span>
                  <input type="text"
                         class="form-control"
                         name="txtanocolacao"
                         maxlength="4"
                         placeholder="Digite o ano"
                         formControlName="anoColacaoGrau"                         
                         mask="0000"
                         (keypress)="soNumeros($event)"
                         appOnlyNumbers />
                </div>
              </div>
            </div>

          </div>
          <!-- FIM DO FACULDADE -->

          <!-- INICÍO DO CONTATO -->
          <div class="row mb-1">
            <label class="d-block">
              <b>Contato - Informe ao menos um telefone
              <label class="asterisco">&nbsp;*</label></b>
            </label>
            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Tel. Residencial</span>
                  <input type="text"
                         class="form-control"
                         name="txtTelResidencial"
                         minlength="13"
                         maxlength="13" mask="(00)0000-0000"
                         placeholder="Digite o telefone residencial"
                         formControlName="residencial"
                         id="residencial"
                         (blur)="telefoneObrigatorio();validarTamanhoTelefone('residencial')"
                         inputrestriction="somentenumeros"
                         (keypress)="soNumeros($event)"
                         [ngClass]="{ 'is-invalid': isEmpityTelefone && hasRequired('residencial') && hasRequired('comercial') || tamanhoTelInvalido}" />
                </div>
                <div *ngIf="(hasRequired('residencial') && hasRequired('comercial') && hasRequired('celular') && isEmpityTelefone)" class="text-danger mensagemAlert">
                  {{ this.msgTelefone }}
                </div>
                <div *ngIf="tamanhoTelInvalido && tipoTelefone === 'residencial'" class="text-danger mensagemAlert">
                  {{ this.msgTelefone }}
                </div>
              </div>
            </div>
            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Tel. Comercial</span>
                  <input type="text"
                         class="form-control"
                         name="txtTelComercial"
                         minlength="13"
                         maxlength="13" mask="(00)0000-0000"
                         placeholder="Digite o telefone comercial"
                         formControlName="comercial"
                         id="comercial"
                         (blur)="telefoneObrigatorio();validarTamanhoTelefone('comercial')"
                         inputrestriction="somentenumeros"
                         (keypress)="soNumeros($event)"
                         [ngClass]="{ 'is-invalid': isEmpityTelefone && hasRequired('residencial') && hasRequired('comercial') || tamanhoTelInvalido}" />
                </div>
                <div *ngIf="(hasRequired('residencial') && hasRequired('comercial') && hasRequired('celular') && isEmpityTelefone)" class="text-danger mensagemAlert">
                  {{ this.msgTelefone }}
                </div>
                <div *ngIf="tamanhoTelInvalido && tipoTelefone === 'comercial'" class="text-danger mensagemAlert">
                  {{ this.msgTelefone }}
                </div>
              </div>
            </div>
            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Celular
                    <label class="asterisco" *ngIf="isAutorizaSMS">&nbsp;*</label>
                  </span>
                  <input type="text"
                         class="form-control"
                         name="txtCelular"
                         minlength="14" maxlength="14"
                         mask="(00)00000-0000"
                         placeholder="Digite o celular"
                         formControlName="celular"
                         inputrestriction="somentenumeros"
                         (keypress)="soNumeros($event)"
                         id="celular"
                        (blur)="celularObrigatorio();telefoneObrigatorio();validarTamanhoTelefone('celular')"
                        [ngClass]="{ 'is-invalid': (isAutorizaSMS || isEmpityTelefone) && hasRequired('celular') || tamanhoTelInvalido}" />
                </div>
                <div *ngIf="(hasRequired('residencial') && hasRequired('comercial') && hasRequired('celular') && isEmpityTelefone)" class="text-danger mensagemAlert">
                  {{ this.msgTelefone }}
                </div>
                <div *ngIf="tamanhoTelInvalido && tipoTelefone === 'celular'" class="text-danger mensagemAlert">
                  {{ this.msgTelefone }}
                </div>
                <div *ngIf="isAutorizaSMS && hasRequired('celular') && (!tamanhoTelInvalido && tipoTelefone === 'celular')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-sm-12 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">E-mail
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="email" class="form-control" name="txtEmail" maxlength="50" placeholder="Digite o e-mail"
                    formControlName="email"
                    [ngClass]="{'is-invalid': fichaInsc.email.errors && fichaInsc.email.touched }" />
                </div>
              </div>
              <div *ngIf="fichaInsc.email.errors?.required && fichaInsc.email.touched"
                class="text-danger mensagemAlert">
                {{ this.msgAlert }}
              </div>
              <div *ngIf="fichaInsc.email.errors?.email && fichaInsc.email.touched" class="text-danger mensagemAlert">
                {{ this.msgEmail }}
              </div>
            </div>
            <div class="col-sm-12 mb-1">
              <div class="form-group">
                <div class="form-check">
                  <input type="checkbox"
                         class="form-check-input"
                         name="chkSms"
                         formControlName="autorizaSMS"
                        (change)="celularObrigatorio()" />
                  <label class="form-check-label">Autorizo o envio de informações via SMS.</label>
                </div>
                <div class="form-check">
                  <input type="checkbox"
                         class="form-check-input"
                         name="chkInfPos"
                         formControlName="autorizaInfoPos" />
                  <label class="form-check-label">Aceito receber e-mails sobre os cursos de extensão e pós-graduação da
                    EMERJ.</label>
                </div>
              </div>
            </div>
          </div>
          <!-- FIM DO CONTATO -->

          <!-- INICÍO DO ENDEREÇO RESIDENCIAL -->
          <div class="row mb-1">
            <label class="d-block"><b>Endereço Residencial</b></label>
            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text etiqueta1End">CEP
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="text"
                         class="form-control"
                         name="txtCep"
                         placeholder="Digite o cep" mask="00.000-000"
                         formControlName="cep" 
                         inputrestriction="somentenumeros"
                         (keypress)="soNumeros($event)"
                        (input)="getAddress(fichaInsc.cep.value)"
                        [ngClass]="{ 'is-invalid': hasRequired('cep') }" />
                </div>
                <div *ngIf="hasRequired('cep')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>
            <div class="col-sm-8 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text etiqueta2End">Logradouro
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="text" class="form-control" name="txtLogradouro" maxlength="70"
                    placeholder="Digite o logradouro" formControlName="logradouro"
                    [ngClass]="{ 'is-invalid': hasRequired('logradouro') }" />
                </div>
              </div>
              <div *ngIf="hasRequired('logradouro')" class="text-danger mensagemAlert">
                {{ this.msgAlert }}
              </div>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text etiqueta1End">Número</span>
                  <input type="text"
                         class="form-control"
                         name="txtNumero"
                         maxlength="10"
                         placeholder="Digite o número"
                        formControlName="numero"
                        (blur)="ValidarNumeroComplemento()"
                        [ngClass]="{ 'is-invalid': hasRequired('numero') }" />
                </div>
              </div>
              <div *ngIf="hasRequired('numero')" class="text-danger mensagemAlert">
                {{ this.msgAlertEndereco }}
              </div>
            </div>
            <div class="col-sm-8 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text etiqueta2End">Complemento</span>
                  <input type="text"
                         class="form-control"
                         name="txtComplemento"
                         maxlength="40"
                         placeholder="Digite o complemento"
                         formControlName="complemento"
                         (blur)="ValidarNumeroComplemento()"
                         [ngClass]="{ 'is-invalid': hasRequired('complemento') }" />
                </div>
              </div>
              <div *ngIf="hasRequired('complemento')" class="text-danger mensagemAlert">
                {{ this.msgAlertEndereco }}
              </div>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text etiqueta1End">UF
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <select class="form-select" name="sltUf" formControlName="uf"
                    [ngClass]="{ 'is-invalid': hasRequired('uf') }">
                    <option value="">Selecione</option>
                    <option *ngFor="let ufResidencial of listaComboFederacao" [value]="ufResidencial.codigo">
                      {{ ufResidencial.descricao }}
                    </option>
                  </select>
                </div>
              </div>
              <div *ngIf="hasRequired('uf') " class="text-danger mensagemAlert">
                {{ this.msgAlert }}
              </div>
            </div>
            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text etiqueta2End">Cidade
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="text" class="form-control" name="txtCidade" maxlength="50" placeholder="Digite a cidade"
                    formControlName="cidade" inputrestriction="somenteletras"
                    [ngClass]="{ 'is-invalid': hasRequired('cidade') }" />
                </div>
              </div>
              <div *ngIf="hasRequired('cidade')" class="text-danger mensagemAlert">
                {{ this.msgAlert }}
              </div>
            </div>
            <div class="col-sm-4 mb-1">
              <div class="form-group">
                <div class="input-group input-group-sm">
                  <span class="input-group-text etiqueta1End">Bairro
                    <label class="asterisco">&nbsp;*</label>
                  </span>
                  <input type="text" class="form-control" name="txtBairro" maxlength="50" placeholder="Digite o bairro"
                    formControlName="bairro" inputrestriction="somenteletras"
                    [ngClass]="{ 'is-invalid': hasRequired('bairro') }" />
                </div>
              </div>
              <div *ngIf="hasRequired('bairro')" class="text-danger mensagemAlert">
                {{ this.msgAlert }}
              </div>
            </div>
          </div>
          <!-- FIM DO ENDEREÇO RESIDENCIAL  -->

          <!-- INICÍO DO PORTADOR DE NECESSIDADES ESPECIAIS E DEFICIENCIA -->
          <div class="row mb-1">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="d-inline">
                  <b>É portador de necessidades especiais?</b>
                  <label class="asterisco">&nbsp;*</label>
                </label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text">
                    <div class="form-check form-check-inline" *ngFor="let especial of listaRadioNecessEspecial">
                      <input class="form-check-input" type="radio" formControlName="portador" [id]="especial.codigo"
                        [value]="especial.codigo"
                        (change)="habilitaCampoTipoDeficiencia('portador')" />
                      <label [for]="especial.codigo" class="form-check-label">{{ especial.descricao }}</label>
                    </div>
                    <div *ngIf="hasRequired('portador')" class="text-danger mensagemAlert">
                      {{ this.msgAlert }}
                    </div>
                  </span>
                  <span class="form-control text-center">
                    <select class="form-select p-0"
                            formControlName="codigoDef"
                            [ngClass]="{'is-invalid': isTipoDeficiencia && hasRequired('codigoDef')}" >
                      <option value=''>Selecione</option>
                      <option *ngFor="let deficiencia of listaComboDeficiencia" [value]="deficiencia.codigo">
                        {{ deficiencia.descricao }}
                      </option>
                    </select>
                  </span>
                </div>
                <div *ngIf="isTipoDeficiencia && hasRequired('codigoDef')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="d-inline">
                  <b>Necessita de Apoio?</b>
                  <label class="asterisco" *ngIf="isReadOnly">&nbsp;<b>*</b></label>
                </label>
                <div class="input-group input-group-sm">
                    <label class="input-group-text">
                      <input type="checkbox"
                            class="form-check-input"
                            name="chkApoio"
                            formControlName="necessitaApoio"
                            (change)="habilitaCampoObservacao('necessitaApoio')"/>&nbsp;Sim
                    </label>
                    <textarea type="text"
                              class="form-control"
                              name="txtObsApoio"
                              maxlength="100"
                              placeholder="Digite a observação"
                              formControlName="observacao"
                              rows="1"
                              style="resize: none;"
                              (input)="habilitaCampoObservacao('necessitaApoio','OBS')"
                              [ngClass]="{'is-invalid': isReadOnly && hasRequired('observacao')}">
                    </textarea>
                </div>
                <div *ngIf="isReadOnly && hasRequired('observacao')" class="text-danger mensagemAlert">
                  {{ this.msgAlert }}
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->

        <div class="card p-0">
          <div class="card-header p-1 fw-bold">Atenção</div>
          <div class="card-body p-1">
            <p class="card-text">
              O candidato que necessita de apoio para a realização da prova deverá formalizar o pedido, mediante requerimento, na Secretaria Acadêmica da EMERJ, presencialmente ou através do e-mail emerj.protacademico@tjrj.jus.br, no prazo da inscrição, anexando os documentos comprobatórios, se necessário.
            </p>
          </div>
        </div>

        <div class="row mb-1 mt-1">
            <div class="col-sm-12">
              <button class="btn btn-sm btn-primary azulTopo" name="Gravar" type="submit"
                [disabled]="habilitaBtnAvancar()">
                Avançar&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            </div>
        </div>

      </form>
  </div>

